import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetSession(userId: string) {
  return useQuery(queries.users.getSessionByUserId(userId))
}
